export function isEmpty(text: string) {
	return text === undefined || text === null || text.length === 0;
}

export const areEqual = (first: string, second: string): boolean => {
	return first?.toLowerCase() === second?.toLowerCase();
};
